import { render, staticRenderFns } from "./KrutiDev-Hindi-Test-Settings.vue?vue&type=template&id=1a6cb66c&"
import script from "./KrutiDev-Hindi-Test-Settings.vue?vue&type=script&lang=js&"
export * from "./KrutiDev-Hindi-Test-Settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports